import React, { Component } from "react";
// import "../initialPage/initial.scss";
import { Col, Row } from 'bootstrap-4-react';

class HeaderPointSalePage extends Component {
  constructor(props) {
    super(props);
    this.state = {

    }
    
  }

  componentDidMount() {  }

  render() {
    const { typeHeader, renderView, signedIn, } = this.props.initState

    return (
      <div style={{ height: (typeHeader === 0 ? '60px' : '60px'), overflow: 'hidden', position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1, }} >
        {/* HEADER */}
        <div style={{ background: '#DA3A2F', height: 58, }}>
          <Row>
            <Col>
              <p className="initialPage__headerText" style={{ lineHeight: 'inherit', textAlign: 'left', paddingLeft: 10, }}>{signedIn.nombre} {signedIn.apellidos}</p>
              <p
                onClick={() => {
                  localStorage.removeItem('hg_app_s');
                  window.location.reload()
                }}
                className="initialPage__headerText" style={{ lineHeight: '13px', textAlign: 'left', paddingLeft: '10px', fontSize: '.8rem', fontWeight: 'bold', cursor: 'pointer', }}>Cerrar sesión</p>
            </Col>
            <Col style={{ textAlign: 'center', }}>
              {/*<img src="img/hgapp/logohg.png" alt="banner" style={{ width: 58, height: 58, objectFit:'contain', borderRadius: '100%', padding: 5, }} />*/}
            </Col>
            <Col style={{ textAlign: 'right', paddingTop: 5, position: 'relative', right: 10, cursor: 'pointer' }}>
            </Col>
          </Row>
        </div>

        {/* SUBHEADER */}


        { this.makeSubheaderByToken() }
      </div>
    );
  }

  makeSubheaderByToken() {
    const { viewApp, tabProgresoActive } = this.props.initState

    if(viewApp === 'admin') {
      return (
        <div className="initialPage__subheader">
          <Row className="initialPage__subheaderTabs">
            <Col onClick={ () => { this.props.initsetState({ tabProgresoActive: 1 }) } }>
              <p>Venta</p>
              { tabProgresoActive === 1 ? ( <div className="initialPage__tabActive"></div> ) : null }
            </Col>
            <Col onClick={ () => { this.props.initsetState({ tabProgresoActive: 2 }) } }>
              <p>Gastos</p>
              { tabProgresoActive === 2 ? ( <div className="initialPage__tabActive"></div> ) : null }
            </Col>
            <Col onClick={ () => { this.props.initsetState({ tabProgresoActive: 3 }) } }>
              <p>Almacén</p>
              { tabProgresoActive === 3 ? ( <div className="initialPage__tabActive"></div> ) : null }
            </Col>
            <Col onClick={ () => { this.props.initsetState({ tabProgresoActive: 4 }) } }>
              <p>Utilidad</p>
              { tabProgresoActive === 4 ? ( <div className="initialPage__tabActive"></div> ) : null }
            </Col>
          </Row>
        </div>
      )
    } else if(viewApp === 'user') {
      return null
    }
  }

};

export default HeaderPointSalePage